import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  inputList: {
    '&&': {
      scrollbarWidth: '3px',
      scrollbarColor: `${theme.palette.custom.grey2} ${theme.palette.custom.grey2}`,
      '&::-webkit-scrollbar': {
        width: '3px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },
}))

export { useStyles }
